import CheckCircleIcon from '@mui/icons-material/CheckCircleOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { colors } from '@mui/material';

export const anchorToast = {
  vertical: 'top',
  horizontal: 'center'
};

export const toastTypes = {
  success: {
    type: 'success',
    defaultMessage: 'toasts.success',
    Icon: CheckCircleIcon,
    backgroundColor: colors.green[600]
  },
  error: {
    type: 'error',
    Icon: ErrorOutlineOutlinedIcon,
    backgroundColor: colors.red[600]
  },
  warning: {
    type: 'warning',
    defaultMessage: '',
    Icon: ReportProblemOutlinedIcon,
    backgroundColor: colors.orange[600]
  }
};
